import LogoSage from './LogoSage'

export default LogoSage
// eslint-disable-next-line import/export
export * from './LogoSage'
